import GoogleIcon from "@/components/icons/GoogleIcon";

type GoogleSignInButtonProps = {
  authenticityToken: string;
};

export default function GoogleSignInButton({ authenticityToken }: GoogleSignInButtonProps) {
  return (
    <form action="/auth/google" method="post">
      <input type="hidden" name="authenticity_token" value={authenticityToken} />
      <button
        id="google-sign-in"
        data-testid="google-sign-in"
        type="submit"
        className="btn relative w-full border border-gray-300 bg-white py-3 text-gray-700 hover:border-gray-400 hover:bg-gray-50 focus:ring-primary"
      >
        <span className="absolute inset-y-0 left-0 flex items-center pl-4">
          <GoogleIcon />
        </span>
        <span className="font-medium">Continue with Google</span>
      </button>
    </form>
  );
}
